import { useEffect } from 'react';

export const useLogError = (error?: unknown) =>
  useEffect(() => {
    if (error instanceof Error) {
      // eslint-disable-next-line no-console -- log error to console
      console.error(error);
    }
  }, [error]);
